const doc = [({"en":({"js":({"admin":({"sheet_layouts":({"show":({"duplicate_box_icon":({"the_box_was_duplicated":"The box was duplicated."})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;